export const LangText: any = {
    us: {
        product_name: 'EcoFlow STREAM Balcony Solar System',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Buy Now',
    },
};
